<template>
  <div
    class="game_selector d-flex-row space-between"
    :class="[isOpen && 'active']"
    v-click-outside="closeOutside"
    @click="handleDropChange"
  >
    <div class="d-flex-row justify-start flex-9">
      <NuxtImg
        class="icon"
        :src="selected.icon"
        :alt="'Selected game icon ' + selected.title"
        style="width: 30px; height: 30px"
        provider="cloudflare"
      />
      <h4 class="t-white font-family-2 bold-m white-space-no selected_title">
        {{ selectedTitle }}
      </h4>
    </div>

    <div class="div"><DoubleChevMono /></div>

    <transition name="slide-fade-top" mode="out-in">
      <div
        class="game_list_dropdown d-flex-column justify-start align-start"
        v-if="isOpen"
        @mouseleave="exitHover"
      >
        <div class="content_container">
          <div class="d-flex-column justify-start align-start games">
            <button
              class="game_nav d-flex-row justify-start height-max-content"
              v-for="game in games"
              :key="game.slug"
              @click.stop="handleRowClick(game)"
              @mouseenter="hover(game)"
              :class="[
                gameSelectorGame.title === game.title ? 'active_nav' : '',
                game.disabled && 'disabled_hover',
              ]"
            >
              <div
                class="d-flex-row justify-start flex-6"
                :class="[game.disabled && 'disabled']"
              >
                <NuxtImg
                  class="game_icon"
                  :src="game.cf_icon"
                  :alt="game.title + ' game image'"
                  provider="cloudflare"
                  preload
                />
                <label class="t-white medium-l font-family-2 cursor-pointer">{{
                  game.title
                }}</label>
              </div>
              <div
                class="d-flex-row justify-end flex-4"
                v-if="game?.reqsDisabled"
              >
                <label class="medium-s font-family-1 t-orange show_color">{{
                  $t("work_with_us.coming_soon")
                }}</label>
              </div>
              <div class="d-flex-row justify-end flex-4" v-if="game?.hasNew">
                <label
                  class="medium-s font-family-1 t-yellow show_color caps"
                  >{{ $t("app.new_mode") }}</label
                >
              </div>
              <div
                class="d-flex-row justify-end flex-4"
                v-if="game?.hasNewGame"
              >
                <label
                  class="medium-s font-family-1 t-yellow show_color caps"
                  >{{ $t("app.new") }}</label
                >
              </div>
            </button>
          </div>
          <hr />
          <LazyCommonGameSelectorPacks
            :selected-game-slug="gameSelectorGame.slug"
            :is-open="isOpen"
            v-if="gameSelectorGame?.slug"
          />
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
import DoubleChevMono from "../icons/DoubleChevMono.vue";
import { ref, computed, watch } from "vue";
import { games } from "~/configurations/games.config";
// HOOKS
const { t } = useI18n();
const localePath = useLocalePath();
const router = useRouter();

// REACTIVE VARIABLES
const isOpen = ref(false);
const packs = ref([]);

const selectedTitle = computed(() => {
  if (selected.value.title === "app.select_game") {
    return t("app.select_game");
  }
  return selected.value.title;
});

const selected = ref({
  icon: "/icons/controller.webp",
  title: "app.select_game",
  slug: "",
});

const gameSelectorGame = ref({
  title: "",
  slug: "",
});

const route = router.currentRoute;

// METHODS
const handleDropChange = () => {
  isOpen.value = !isOpen.value;
  if (!isOpen.value) {
    exitHover();
  }
};

const closeOutside = () => {
  isOpen.value = false;
  exitHover();
};

const handleSelected = () => {
  const routeName = route.value?.meta?.pageInfo;
  if (routeName?.name === "home") {
    selected.value = {
      title: "app.select_game",
      icon: "/icons/controller.webp",
      slug: "",
    };
  } else if (route.value?.params?.gameSlug) {
    const game = games.find((gam) => gam.slug === route.value.params.gameSlug);
    if (game) {
      selected.value = {
        icon: game.cf_icon,
        title: game.title,
        slug: game.slug,
      };
      gameSelectorGame.value = {
        title: game.title,
      };
    } else {
      selected.value = {
        title: t("booster_profile.games"),
        icon: "/icons/controller.webp",
        slug: "",
      };
    }
  }
};

const handleRowClick = (game) => {
  if (game?.disabled) return;
  let windowWindow = window?.innerWidth || 0;
  gameSelectorGame.value = {
    title: game.title,
  };
  selected.value = {
    icon: game.icon,
    title: game.title,
    slug: game.slug,
  };
  let path = "";
  if (game?.slug) {
    path = `/${game?.slug}`;
  } else if (game.title === "app.select_game") {
    path = "/";
  }

  router.push(localePath(path));
  handleDropChange();
  if (windowWindow > 900) {
    gameSelectorGame.value = {
      title: game.title,
      slug: game.slug,
    };
  }
};

handleSelected();
const hover = (game) => {
  if (game?.disabled) return;

  gameSelectorGame.value = {
    title: game.title,
    slug: game.slug,
  };
};
const exitHover = () => {
  gameSelectorGame.value = {
    title: "",
    slug: "",
  };
};

watch(router.currentRoute, (newVal) => {
  handleSelected();
});
</script>
